module.exports = __webpack_public_path__ + "static/media/carousel12.145804ea.jpeg";